module.exports = __webpack_public_path__ + "assets/valance-classic-scallop.4f4d25f6.svg";